import { Dropdown, MenuProps } from 'antd'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button, Chevron, NavigationModal } from '@lmc/ui-kit'
import { useState } from 'react'
import dayjs from 'dayjs'
import useRotaRemove from 'screens/Rostering/hooks/useRotaRemove'
import {
  ISO_STRING_FORMAT,
  getDateWithoutUTC,
} from 'screens/Rostering/utils.datetime'
import { DAILY, WEEKLY } from 'screens/Rostering/constants'

type RotaBuilderDropdownProps = {
  currentDate: dayjs.Dayjs
  isDailyView: boolean
  onViewChange: (event: any) => void
  isZoomed?: boolean
  handleZoom?: () => void
}

const RotaBuilderDropdown = ({
  currentDate,
  isDailyView,
  onViewChange,
  isZoomed,
  handleZoom,
}: RotaBuilderDropdownProps) => {
  const { t } = useTranslation()

  const [showPrompt, setShowPrompt] = useState<boolean>(false)

  const { removeRota } = useRotaRemove()

  const getMenuProps = () => {
    const items: MenuProps['items'] = [
      {
        label: isDailyView
          ? t('SWITCH_TO_WEEKLY_VIEW')
          : t('SWITCH_TO_DAILY_VIEW'),
        key: 'switch-view',
        onClick: () => {
          onViewChange({ target: { value: isDailyView ? WEEKLY : DAILY } })
        },
      },
      isDailyView && handleZoom && {
        label: t(isZoomed ? 'ZOOM_OUT' : 'ZOOM_IN'),
        key: 'zoom',
        onClick: handleZoom,
      },
      {
        type: 'divider',
      },
      {
        label: t('RESET_ROTA'),
        key: 'reset-rota',
        onClick: () => {
          setShowPrompt(true)
        },
      },
    ].filter(Boolean) as MenuProps['items']

    return { items }
  }

  const handleConfirmNavigation = () => {
    removeRota?.({ date: getDateWithoutUTC(currentDate, ISO_STRING_FORMAT) })

    setShowPrompt(false)
  }

  return (
    <>
      <Dropdown menu={getMenuProps()} trigger={['hover']}>
        <StyledButton variant="text">
          {t('OPTIONS')} <Chevron direction="down" />
        </StyledButton>
      </Dropdown>
      <NavigationModal
        modalTitle={t('RESET_ROTA_MODAL_TITLE')}
        modalContentText={t('RESET_ROTA_MODAL_DESCRIPTION')}
        modalConfirmText={t('RESET_ROTA')}
        modalCancelText={t('CANCEL')}
        showPrompt={showPrompt}
        confirmNavigation={handleConfirmNavigation}
        cancelNavigation={() => setShowPrompt(false)}
      />
    </>
  )
}

const StyledButton = styled(Button)`
  color: ${(props) => props.theme.color.neutral.color3};
  &:hover {
    color: ${(props) => props.theme.color.hover.primary};
  }
`

export default RotaBuilderDropdown
